import { ClientUserState } from '../../../../shared/scripts/ClientUserState.ts';
import { setElementOnClick } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { UIMProfileController } from './body/profile/UIMProfileController.ts';
import { ViewPopupLogin } from '../../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts';
import { EntryShared } from '../../../../shared/scripts/EntryShared.ts';
export class UIMProfileOverlayController {
    show() {
        var _ClientUserState_userState;
        if (!((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn)) {
            new ViewPopupLogin();
            return;
        }
        this.previousScene = this.sceneController.scene;
        this.sceneController.loadScene(undefined);
        this.overlayContainer.classList.remove('hidden');
        this.backButton.classList.add('visible');
        EntryShared.sendPageVisitAnalyticEvent('/profile');
        if (this.profileController == undefined) {
            var _ClientUserState_userState1;
            var _ClientUserState_userState_username;
            const username = (_ClientUserState_userState_username = (_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.username) !== null && _ClientUserState_userState_username !== void 0 ? _ClientUserState_userState_username : '';
            this.profileController = new UIMProfileController(username);
        }
    }
    hide() {
        const previousScene = this.previousScene;
        this.hideAndClearPreviousScene();
        this.sceneController.loadScene(previousScene);
    }
    hideAndClearPreviousScene() {
        this.previousScene = undefined;
        this.overlayContainer.classList.add('hidden');
        this.backButton.classList.remove('visible');
    }
    constructor(sceneController){
        this.previousScene = undefined;
        this.profileController = undefined;
        this.sceneController = sceneController;
        this.overlayContainer = document.getElementById('profile-overlay-container');
        this.backButton = document.getElementById('header-back-button');
        setElementOnClick(this.backButton, ()=>this.hide());
        this.backButton.style.transition = '';
    }
}
